import { render, staticRenderFns } from "./BtnAtualizarConsultoria.vue?vue&type=template&id=910b7cde"
import script from "./BtnAtualizarConsultoria.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarConsultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports